module.exports = __webpack_public_path__ + "img/65400.492647d9.jpg";